import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { languageSelector } from 'store/consumerPreferences/selectors';

export const useLanguageSwitcher = translations => {
  const currentLanguage = useSelector(languageSelector);
  const [text, setText] = useState(translations[currentLanguage]);

  useEffect(() => {
    setText(translations[currentLanguage]);
  }, [currentLanguage, translations]);

  return text || {};
};
